module.exports = "/images/ye.svg?3afd406cd6714e12141f75a80e48bb55";